import React from 'react';

interface AIOverlayProps {
    isLoading: boolean;
    isSpeaking: boolean;
    isFr: boolean;
}

export const AIOverlay: React.FC<AIOverlayProps> = ({ isLoading, isSpeaking, isFr }) => {
    return (
        <div className="pointer-events-none fixed top-24 left-1/2 -translate-x-1/2 z-[100] flex flex-col items-center gap-4">
            {isLoading && (
                <div className="flex items-center gap-3 px-6 py-3 rounded-full bg-smart-gold/20 border border-smart-gold/40 backdrop-blur-3xl animate-fade-in-up shadow-2xl pointer-events-auto">
                    <div className="w-2 h-2 bg-smart-gold rounded-full animate-ping"></div>
                    <span className="text-[10px] font-black text-smart-gold uppercase tracking-[0.3em]">
                        {isFr ? 'IA Gemini en cours d\'analyse...' : 'Gemini AI is analyzing...'}
                    </span>
                </div>
            )}
            
            {isSpeaking && (
                <div className="flex items-center gap-4 px-8 py-4 rounded-full bg-cyan-500/20 border border-cyan-500/40 backdrop-blur-3xl animate-fade-in-up shadow-2xl pointer-events-auto">
                    <div className="flex gap-1">
                        <div className="w-1 h-4 bg-cyan-400 animate-pulse"></div>
                        <div className="w-1 h-6 bg-cyan-300 animate-pulse delay-75"></div>
                        <div className="w-1 h-3 bg-cyan-400 animate-pulse delay-150"></div>
                    </div>
                    <span className="text-xs font-black text-cyan-400 uppercase tracking-widest italic">
                        {isFr ? 'Écoute vocale active' : 'Voice coach active'}
                    </span>
                </div>
            )}
        </div>
    );
};